import React, { useCallback, useEffect, useRef, useState } from "react";
import "./DrAce.scss";
// @ts-ignore
import lottie from "../../../assets/lottie/drACE_01.lottie";
import '@dotlottie/player-component';
import { useDrAce } from "../../../hooks/useDrAce";
import { TextIcon } from "../../TextIcon/TextIcon";

export function DrAce() {
    const { content, setContent } = useDrAce();
    const elmRef = useRef<HTMLDivElement>(null);
    const [delayedContent, setDelayedContent] = useState(content);

    const visible = !!content;

    // Hide Dr Ace when subject changes
    const closeAce = useCallback(() => {
        setContent(undefined);
    }, [setContent]);

    // Hide DrAce after 5 seconds of showing
    useEffect(() => {
        const timeout = setTimeout(() => {
            closeAce();
        }, 10000);
        return () => {
            clearTimeout(timeout);
        }
    }, [content, closeAce]);

    // Set the delayed content
    useEffect(() => {
        if (content) {
            setDelayedContent(content);
        } else {
            // Move Lottie out, because content was unset
            const timeout = setTimeout(() => {
                setDelayedContent(undefined);
            }, 1000);
            return () => {
                clearTimeout(timeout);
            }
        }
    }, [content]);

    return (
        <>
            <div className={`dr-ace-wrapper ${visible ? 'visible' : ''}`} ref={elmRef}>
                <div className="lottie-player" onPointerDown={closeAce}>
                    <dotlottie-player
                        src={lottie}
                        autoplay
                        transparent
                        loop
                        style={{ height: '100%', width: '100%' }}
                    />
                </div>

                <div className="ace-icon-wrapper">
                    {delayedContent?.icon ? <TextIcon icon={delayedContent.icon} /> : null}
                </div>

                <div className="text-balloon-wrapper">
                    <div className="ace-text-wrapper">
                        <div className="ace-text-inner" dangerouslySetInnerHTML={{__html: delayedContent?.text ?? ''}} />
                    </div>
                </div>
            </div>
            {/*<HiddenAce visible={blurredVisible} handleClick={() => setFocus(!focus)} />*/}
        </>
    )
}
